import { Injectable } from '@angular/core';
import { UnsettledPaymentsExportQuery, UnsettledPaymentsExportQueryHandlerBase } from '@skylab-shared/business';

import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(UnsettledPaymentsExportQuery)
@Wrapper(UnsettledPaymentsExportQueryHandlerBase)
export class UnsettledPaymentsExportQueryHandler {
    public constructor(
        http: Http
    ) { }
}
